import ResourceBase from './../shared/resource-base';
import Coordinator from '../coordinators/coordinator-model';
import { deserialize, custom, serialize } from 'serializr';
import ModelSchemas from './../shared/model-schema';
import _ from 'lodash';

const customSchema = custom(
    (jsonValue) => jsonValue,
    (jsonValue, callback, context, currentPropertyValue) => {
        return jsonValue;
    }
);
export default class CoordinatorResource extends ResourceBase {
    constructor() {
        super(Coordinator);
        this.coordinatorSchema = ModelSchemas.createCoordinatorSchema(Coordinator, {
            roles: customSchema,
            credentials: customSchema,
        });
    }

    getCoordinators(token, includeDisabled = true) {
        const payload = { filter: { order: 'name ASC' } };
        if (!includeDisabled) {
            payload.filter['where'] = { disabled: false };
        }
        return new Promise((resolve, reject) => {
            this.find(token, payload)
                .then((coordinators) => {
                    let coordinatorModels = [];
                    coordinators.forEach((coordinatorJSON) => {
                        coordinatorModels.push(deserialize(this.coordinatorSchema, coordinatorJSON));
                    });
                    resolve(coordinatorModels);
                })
                .catch(reject);
        });
    }

    getCoordinator(token, sub) {
        return new Promise((resolve, reject) => {
            this.find(token, { filter: { where: { aspNetUserId: sub } } })
                .then((coordinatorsJSON) => {
                    if (coordinatorsJSON && coordinatorsJSON.length > 0) {
                        let coordinatorJSON = _.first(coordinatorsJSON);
                        resolve(deserialize(this.coordinatorSchema, coordinatorJSON));
                    } else {
                        resolve(null);
                    }
                })
                .catch(reject);
        });
    }

    getCoordinatorsSearch(token, query) {
        return new Promise((resolve, reject) => {
            this.find(token, query)
                .then((coordinatorsJSON) => {
                    let coordinatorModels = [];
                    coordinatorsJSON.forEach((coordinatorJSON) => {
                        coordinatorModels.push(deserialize(this.coordinatorSchema, coordinatorJSON));
                    });
                    resolve(coordinatorModels);
                })
                .catch(reject);
        });
    }

    saveCoordinator(token, coordinatorModel, fields) {
        new Promise((resolve, reject) => {
            this.patch(token, coordinatorModel.coordinatorId, fields)
                .then((res) => {
                    resolve(res);
                })
                .catch(reject);
        });
    }
}



// WEBPACK FOOTER //
// ./src/coordinators/coordinator-resource.js